import { render, staticRenderFns } from "./popup-choose-shen-gou.vue?vue&type=template&id=1812ccfe&scoped=true"
import script from "./popup-choose-shen-gou.vue?vue&type=script&lang=js"
export * from "./popup-choose-shen-gou.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1812ccfe",
  null
  
)

export default component.exports